export type Order = 'asc' | 'desc';

export enum ResponseStatusType {
  FAILED = 'FAILED',
  SUCCESS = 'SUCCESS'
}

export type RoleSortingFields = 'description' | 'displayName' | 'name';

export type PermissionSortingFields = 'description' | 'displayName' | 'name';

export type BarSortingFields = 'name';

export enum WeekDays {
  MONDAY = 'MONDAY',
  TUESDAY = 'TUESDAY',
  WEDNESDAY = 'WEDNESDAY',
  THURSDAY = 'THURSDAY',
  FRIDAY = 'FRIDAY',
  SATURDAY = 'SATURDAY',
  SUNDAY = 'SUNDAY'
}

export enum StitchStatus {
  BOOKED = 'Booked',
  INSPECTED = 'Inspected'
}

export interface PostCodeParams {
  name: string;
}

export interface AutoCompletePostCodeResponse {
  status: number;
  result: PostCodeParams[];
  count: number;
}

export type RemoteSortingFields = 'name';

export interface BaseModel {
  id: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface VisitStitchBookings {
  stitchStatus?: StitchStatus;
  stitchedById?: string;
}

export interface BaseTemperatureRangeEntityModel extends BaseModel {
  minTemperature?: number;
  maxTemperature?: number;
}

export interface BaseTempTrendEntityModel extends BaseModel {
  tempTrend: TemperatureTrend[];
}

export interface TemperatureTrend {
  temperature: number | null;
  date: string | null;
}

export interface IIsPdf {
  isPDF?: boolean;
}

export type TrackedRef = {
  ref: React.RefObject<HTMLDivElement>;
  style: React.CSSProperties;
};
